import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";
import { Box, Flex, Button } from "@chakra-ui/react";
import ThemeSelector from "./ThemeSelector";
import { getThemeSource } from "src/duck/selectors";
import { themeSourceChanged } from "src/duck/actions";
import Modal from "src/components/Modal";

const { nativeTheme } = window.require("@electron/remote");

class ThemeSettings extends Component {
  render() {
    const { t, isOpen, onClose, themeSource, themeSourceChangeHandler } =
      this.props;

    const handleThemeChange = (value) => {
      if (nativeTheme) nativeTheme.themeSource = value;
      themeSourceChangeHandler(value);
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width="280px">
          <Box pt="24px" px="24px">
            <ThemeSelector
              selectedTheme={themeSource}
              onChange={handleThemeChange}
            />
          </Box>
          <Flex mt="22px" pr="8px" pb="8px" justifyContent="flex-end">
            <Button variant="flatPrimary" onClick={onClose} minWidth="80px">
              {t("buttons.ok")}
            </Button>
          </Flex>
        </Box>
      </Modal>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    themeSource: getThemeSource(state)
  };
};
const enhance = compose(
  withTranslation(),
  connect(mapStateToProps, { themeSourceChangeHandler: themeSourceChanged })
);

export default enhance(ThemeSettings);
